import { BorderOptions } from './Container.types';
export var BorderStyle = {
  [BorderOptions.None]: {
    border: 'none'
  },
  [BorderOptions.Regular]: {
    border: 'surface.default',
    borderRadius: 'l'
  },
  [BorderOptions.Dashed]: {
    border: 'input-dashed.enabled',
    borderRadius: 'l'
  }
};
export var BackgroundStyle = {
  default: 'transparent',
  light: 'neutral.lightest',
  white: 'neutral.white'
};
//# sourceMappingURL=Container.theme.utils.js.map